import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Textarea {
    id: string
    label?: string
    error?: string
    txtAreaClassProps?: string
    containerClassProps?: string
    [key: string]: any
}

const Textarea: React.FC<Textarea> = ({ id, label, txtAreaClassProps, containerClassProps, error, className, ...props }) => {
  const TextAreaStyle = 'border border-neutro-200 outline-none p-2 w-full resize-none rounded-md bg-neutro-50 min-h-[100px]'
  const LabelDefaultStyle = 'p-2 block font-medium'
  
  // Função para lidar com o estado de erro do textArea
  const TextAreaDisabledState = (): string => { return props.disabled ? 'border-neutro-200 bg-neutro-50 cursor-not-allowed' : '' }
  const TextAreaErrorState = (): string => { return error && !props.disabled ? 'border-erro-500' : '' }
  const TextAreaFinalStyle = twMerge(TextAreaStyle, txtAreaClassProps, className, TextAreaDisabledState(), TextAreaErrorState())

  const LabelErrorState = (): string => { return error && !props.disabled ? "text-erro-500" : "" }
  const LabelDisabledStyle = (): string => { return props.disabled ? 'text-neutro-200' : 'text-primario-700' }
  const LabelStyle = twMerge(LabelDefaultStyle, LabelDisabledStyle(), LabelErrorState())
  
  return (
    <div className={containerClassProps}>
        { label && <label className={LabelStyle} htmlFor={id}>{label}</label> }
        <textarea className={twMerge(TextAreaFinalStyle)} id={id} {...props}></textarea>
        { error && !props.disabled && <p className='text-erro-500 mt-1'>{error}</p> }
    </div>
  )
}

export default Textarea